import { Component, inject } from '@angular/core';
import { ViewportEnterDirective } from "../viewport-enter-directive";
import { ActiveRoute } from '../active-route';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [ViewportEnterDirective],
  templateUrl: './table.html',
  styleUrl: './table.scss',
})
export class Table {
  activeRoute= inject(ActiveRoute);
  isTableActive:boolean=false;
}
